<template>
    <div class="container">
        <md-dialog :md-active.sync="modalEditar" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.identificacion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoTercero[0].identificacion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.digitoVerif}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="infoTercero[0].digito_verificacion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.nombre}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoTercero[0].nombre" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.correo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoTercero[0].correo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.telefono}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="infoTercero[0].telefono" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.direccion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoTercero[0].direccion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.tipoTercero}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select v-model="infoTercero[0].tipo_tercero" class="form-control">
                            <option value="">{{labels.select}}</option>
                            <option v-for="tercero in listTipoTercero" :key="tercero.id" :value="tercero.tipo_tercero">{{ tercero.descripcion }}</option>
                        </select>
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <b-col cols="7" class="text-left">
                        <md-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</md-button>
                    </b-col>
                    <b-col cols="3" class="text-right">
                        <md-button class="md-primary" @click="guardarTercero">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
        <InacticaItem :InactivaItem="deleteTercero" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
    </div>
</template>

<script>

import Tercero from '../../services/Tercero';
import TipoTerceros from '../../services/TipoTerceros';
import InacticaItem from '../utils/InacticaItem.vue';

export default {
    name:'Editar',
    props:['modalEditar','infoTercero'],
    components: {InacticaItem},
    data:() => ({
        identificacion : '',
        digitoVerif : null,
        nombre : '',
        correo : '',
        telefono : '',
        direccion : '',
        tipoTercero : '',
        listTipoTercero : [],
        deleteTercero : false,
        idTercero : null
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Editar Tercero',
                    save : 'Guardar',
                    delete : 'Eliminar',
                    close : 'Cerrar',
                    identificacion : 'Identificación',
                    digitoVerif : 'Digito verificación',
                    nombre : 'Nombre',
                    correo : 'Correo',
                    telefono : 'Telefono',
                    direccion : 'Dirección',
                    tipoTercero : 'Tipo tercero',
                    select : 'Seleccione...'
                }
            }else{
                return {
                    title : 'Edit Third',
                    save : 'Save',
                    delete : 'Eliminar',
                    close : 'Close',
                    identificacion : 'ID',
                    digitoVerif : 'Verification digit',
                    nombre : 'Name',
                    correo : 'Email',
                    telefono : 'Phone',
                    direccion : 'Address',
                    tipoTercero : 'Tipo tercero',
                    select : 'Select...'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        cierraModalDelet(){
            this.deleteTercero = false
        },
        guardarTercero(){
            const valores = [
                this.infoTercero[0].identificacion, 
                this.infoTercero[0].digito_verificacion, 
                this.infoTercero[0].nombre,
                this.infoTercero[0].correo,
                this.infoTercero[0].telefono,
                this.infoTercero[0].direccion,
                this.infoTercero[0].tipo_tercero
            ]
            // console.log(valores);
            if(valores.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                // this.$toast.success('Envia form')
                let info = {
                    'id' : this.infoTercero[0].id,
                    'identificacion'  : this.infoTercero[0].identificacion, 
                    'digitoVerificacion'  : this.infoTercero[0].digito_verificacion, 
                    'nombre'  : this.infoTercero[0].nombre,
                    'correo'  : this.infoTercero[0].correo,
                    'telefono'  : this.infoTercero[0].telefono,
                    'direccion'  : this.infoTercero[0].direccion,
                    'tipoTercero'  : this.infoTercero[0].tipo_tercero,
                    'idUser'    : this.$store.state.userId
                }

                Tercero.updateTerceroById(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tercero ingresado ya existe.')
                    }
                })
                .catch((error) => { console.log(error) })
            }
        },
        eliminaRegistro(){
            this.idTercero = this.infoTercero[0].id
            this.deleteTercero = true
        },
        confirmInactivate(){
            Tercero.deleteTercero(this.idTercero)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    location. reload()                
                }
            })
            .catch((error) => error)
        }
    },
    mounted(){
        TipoTerceros.getAllTipoTerceros()
        .then((res) => {
            // console.log(res.data.listTipoTerceros);
            this.listTipoTercero = res.data.listTipoTerceros
        })
        .catch((error) => {console.log(error)})
    }
}
</script>

<style>

</style>